module.exports = __webpack_public_path__ + "static/media/logo.ada05c63.svg";